module.exports = "/_next/static/media/793376975609d14d5ce5137ec557b6ef.svg";